<template>
  <core-popup
    show
  >
    <template #body>
      <div
        :class="$style.confirm_popup"
        :style="{ maxWidth: config.width ? config.width + 'px' : 420 + 'px' }"
      >
        <div
          :class="$style.confirm_message"
          v-html="config.message"
        />

        <div
          v-if="config.footerText"
          :class="$style.footer_message"
        >
          <p
            v-html="config.footerText"
          />
        </div>

        <div :class="$style.buttons">
          <vgp-button
            v-if="config.cancel"
            type="secondary"
            :label="config.cancel"
            :small="true"
            @onClick="closeClick"
          />
          <vgp-button
            v-if="config.ok"
            :style="{ marginLeft: 16 + 'px' }"
            type="primary"
            :label="config.ok"
            :small="true"
            @onClick="confirmClick"
          />
        </div>
      </div>
    </template>
  </core-popup>
</template>

<script>
import corePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import vgpButton from '$$vueCmp//globalButton/vgpButton.vue';

export default {
  components: {
    corePopup,
    vgpButton,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeClick() {
      this.$store.dispatch('globalPopup/close');
    },
    confirmClick() {
      this.$store.dispatch('globalPopup/confirm');
    },
  },
};
</script>

<style module src="./confirmPopup.less" lang="less"></style>
